import { Modal, Input, Row, Col, Form, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SubscriptionServices from "../../services/SubscriptionServices";
import SectionLoader from "../Loaders/SectionLoader";

const { TextArea } = Input;

const UpdateTemplate = ({ visible, onClose }) => {
  const params = useParams();
  const [values, setValues] = useState({
    subscriptionId: params?.id,
    template_name: "",
    subject: "",
    html_body: "",
    text_body: "",
  });
  const [listOfTemplates, setListOfTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTemplate, setLoadingTemplate] = useState(false);

  useEffect(() => {
    const fetchSubscriptionTemplates = async () => {
      try {
        setLoadingTemplate(true);
        if (visible) {
          const response = await SubscriptionServices.getSubscriptionTemplates(
            params.id
          );

          setListOfTemplates(response?.data?.templates || []);
          setValues((prevValues) => ({
            ...prevValues,
            template_name: response?.data?.templates[0]?.template_name || "",
          }));
          await fetchTemplateByName(
            response?.data?.templates[0]?.template_name
          );
        }
      } catch (error) {
        console.error("Failed to fetch subscription template:", error);
      } finally {
        setLoadingTemplate(false);
      }
    };
    fetchSubscriptionTemplates();
  }, [visible]);

  useEffect(() => {
    if (values.template_name) {
      fetchTemplateByName(values.template_name);
    }
  }, [values.template_name]);

  const fetchTemplateByName = async (templateName) => {
    setLoadingTemplate(true);
    try {
      const response = await SubscriptionServices.getTemplateByName(
        params.id,
        templateName
      );
      setValues((prevValues) => ({
        ...prevValues,
        subject: response?.data?.templates[0]?.subject || "",
        html_body: response?.data?.templates[0]?.html_body || "",
        text_body: response?.data?.templates[0]?.text_body || "",
      }));
    } catch (error) {
      console.error("Error fetching template by name:", error);
    } finally {
      setLoadingTemplate(false);
    }
  };

  const onCloseModal = (success) => {
    setValues((prevValues) => ({
      ...prevValues,
      html_body: "",
      subject: "",
    }));
    onClose(success);
  };

  const handleSetNewTemplate = async () => {
    try {
      setLoading(true);
      const body = {
        subscription_id: values?.subscriptionId,
        template_name: values?.template_name,
        subject: values?.subject,
        html_body: values?.html_body,
        text_body: values?.text_body,
      };
      await SubscriptionServices.updateSubscriptionInviteTemplate(body);

      onCloseModal(true);
    } catch (error) {
      console.error("Error al actualizar la plantilla:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      open={visible}
      onCancel={() => onCloseModal(false)}
      onOk={() => handleSetNewTemplate()}
      title="Actualizar plantilla"
      width={1200}
      confirmLoading={loading}
      okButtonProps={{
        disabled: loading || !values?.html_body || !values?.subject,
      }}
    >
      {loadingTemplate && <SectionLoader />}
      <Form layout="vertical">
        <Col xs={24} md={12}>
          <Form.Item label="Seleccionar plantilla">
            <Select
              className="w-1/2"
              options={listOfTemplates.map((template) => ({
                label: template.template_name,
                value: template.template_name,
              }))}
              placeholder="Seleccionar plantilla"
              value={values?.template_name}
              onChange={(value) =>
                setValues((prevValues) => ({
                  ...prevValues,
                  template_name: value,
                }))
              }
            />
          </Form.Item>
        </Col>
        <Form.Item label="Asunto del correo">
          <Input
            className="w-1/2"
            placeholder="Invitación a Motivia"
            value={values?.subject}
            onChange={(e) =>
              setValues((prevValues) => ({
                ...prevValues,
                subject: e.target.value,
              }))
            }
          />
        </Form.Item>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item label="Tu template">
              <TextArea
                rows={20}
                placeholder="Pegá tu HTML acá"
                value={values?.html_body}
                onChange={(e) =>
                  setValues((prevValues) => ({
                    ...prevValues,
                    html_body: e.target.value,
                  }))
                }
                style={{ height: "400px", overflowY: "scroll" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Vista previa">
              <div
                className="border border-gray-300 p-2 bg-gray-100"
                style={{
                  height: "400px",
                  overflow: "auto",
                  whiteSpace: "normal",
                }}
                dangerouslySetInnerHTML={{ __html: values.html_body }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateTemplate;
